import { Routes } from "@angular/router";
import { AuthGuard, redirectAuthenticatedGuard } from "./guards/auth.guard";

export const routes: Routes = [
  {
    path: "",
    pathMatch: "full",
    loadComponent: () =>
      import("./components/home/home.component").then((m) => m.HomeComponent),
    canActivate: [redirectAuthenticatedGuard],
  },
  {
    path: "home",
    loadComponent: () =>
      import("./components/home/home.component").then((m) => m.HomeComponent),
    canActivate: [redirectAuthenticatedGuard],
  },
  {
    path: "about",
    loadComponent: () =>
      import("./components/about/about.component").then((m) => m.AboutComponent),
  },
  {
    path: "info/:slug",
    loadComponent: () =>
      import("./components/info-page/info-page.component").then(
        (m) => m.InfoPageComponent
      ),
  },
  {
    path: "contact",
    loadComponent: () =>
      import("./components/contact/contact.component").then(
        (m) => m.ContactComponent
      ),
  },
  {
    path: "faq",
    loadComponent: () =>
      import("./components/faq/faq.component").then((m) => m.FaqComponent),
  },
  {
    path: "terms-and-conditions",
    loadComponent: () =>
      import("./components/terms-and-conditions/terms-and-conditions.component").then(
        (m) => m.TermsAndConditionsComponent
      ),
  },
  {
    path: "privacy-policy",
    loadComponent: () =>
      import("./components/privacy-policy/privacy-policy.component").then(
        (m) => m.PrivacyPolicyComponent
      ),
  },
  {
    path: "verify",
    loadComponent: () =>
      import("./components/shared/verify-route-host/verify-route-host.component").then(
        (m) => m.VerifyRouteHostComponent,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard",
    loadComponent: () =>
      import("./components/dashboard/dashboard.component").then(
        (m) => m.DashboardComponent
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "payments",
        loadComponent: () =>
          import(
            "./components/dashboard/payment-history-modal/payment-history-modal.component"
          ).then((m) => m.PaymentHistoryModalComponent),
      },
      {
        path: "enrollments/:enrollmentId/schedule-history",
        loadComponent: () =>
          import(
            "./components/dashboard/schedule-history-modal/schedule-history-modal.component"
          ).then((m) => m.ScheduleHistoryModalComponent),
      },
      {
        path: "verify",
        loadComponent: () =>
          import(
            "./components/shared/respondent-verification-modal/respondent-verification-modal.component"
          ).then((m) => m.RespondentVerificationModalComponent),
      },
    ],
  },
  {
    path: "courses",
    loadComponent: () =>
      import("./components/courses/courses.component").then(
        (m) => m.CoursesComponent
      ),
    children: [
      {
        path: "verify",
        loadComponent: () =>
          import(
            "./components/shared/respondent-verification-modal/respondent-verification-modal.component"
          ).then((m) => m.RespondentVerificationModalComponent),
      },
    ],
  },
  {
    path: "profile",
    loadComponent: () =>
      import("./components/profile/profile.component").then(
        (m) => m.ProfileComponent
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "profile/communications",
    loadComponent: () =>
      import(
        "./components/profile/communication-history/communication-history.component"
      ).then((m) => m.CommunicationHistoryComponent),
    canActivate: [AuthGuard],
  },
  {
    path: "login",
    loadComponent: () =>
      import("./components/auth/login/login.component").then(
        (m) => m.LoginComponent
      ),
  },
  {
    path: "register",
    loadComponent: () =>
      import("./components/auth/register/simple-register.component").then(
        (m) => m.SimpleRegisterComponent
      ),
  },
  {
    path: "forgot-password",
    loadComponent: () =>
      import("./components/auth/password-recovery/password-recovery.component").then(
        (m) => m.PasswordRecoveryComponent
      ),
  },
  {
    path: "reset-password",
    loadComponent: () =>
      import("./components/auth/password-recovery/password-recovery.component").then(
        (m) => m.PasswordRecoveryComponent
      ),
  },
  {
    path: "password-recovery",
    loadComponent: () =>
      import("./components/auth/password-recovery/password-recovery.component").then(
        (m) => m.PasswordRecoveryComponent
      ),
  },
  { path: "**", redirectTo: "" },
];
